import { render, staticRenderFns } from "./EditProjectProperty.vue?vue&type=template&id=be5e1904&scoped=true&"
import script from "./EditProjectProperty.vue?vue&type=script&lang=js&"
export * from "./EditProjectProperty.vue?vue&type=script&lang=js&"
import style0 from "./EditProjectProperty.vue?vue&type=style&index=0&id=be5e1904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5e1904",
  null
  
)

export default component.exports